export function getDecimalSeparator(number: string | Big) {
  const string = `${number}`;
  if (string.includes(',') && string.includes('.')) return '.';
  if (string.includes('.')) return '.';
  if (string.includes(',')) return ',';
  return null;
}

export function splitOnDecimalSeparator(number: string | Big) {
  const string = `${number}`;
  if (string.includes(',') && string.includes('.')) return string.split('.');
  if (string.includes('.')) return string.split('.');
  if (string.includes(',')) return string.split(',');
  return [string];
}

export function replaceDecimalSeparator(number: string | Big) {
  const string = `${number}`;
  if (string.includes(',') && string.includes('.')) return string.replace(/,/g, '');
  if (string.includes(',')) return string.replace(/,/g, '.');
  return string;
}

export function truncateToPrecision(number: string, maxPrecision = 2) {
  const split = splitOnDecimalSeparator(number);
  const separator = getDecimalSeparator(number);
  const precision = maxPrecision;
  return `${split[0]}${separator}${split[1].substr(0, precision)}`;
}

export function parseValue(value: string | Big): number;

export function parseValue<B extends boolean>(
  value: string | Big,
  returnNullForNan: B
): B extends true ? number | null : number;

export function parseValue(value: string | Big, returnNullForNan?: boolean): number | null {
  const parsed = parseFloat(replaceDecimalSeparator(value));
  if (isNaN(parsed)) return returnNullForNan ? null : 0;
  return parsed;
}

export function shrinkHash(hash: string): string {
  return !hash
    ? ''
    : hash.length <= 10
    ? hash
    : `${hash.substring(0, 6)}...${hash.substring(hash.length - 5)}`;
}
